export default __webpack_public_path__ + "static/media/MACS-CORE-Logo.9c59e8f1.png";